import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  ExternalIntegrationsService,
  ExternalIntegrationPreloaderService,
  ExternalIntegrationsResolver,
  ExternalIntegrationStatusResolver,
  ExternalIntegrationCustomerSyncEndResolver,
  ShopifyAutoconnectRedirectResolver,
  ExternalIntegrationsRepository,
  ShopifyIntegrationService,
  ShopifyIntegrationRepository,
  WooCommerceIntegrationService,
  WooCommerceIntegrationRepository,
  HubspotIntegrationService,
  HubspotIntegrationRepository,
  ZohoIntegrationService,
  ZohoIntegrationRepository,
  ExternalIntegrationCustomerRepository,
  ExternalIntegrationSuccessCustomerGridable,
  ExternalIntegrationFailedCustomerGridable,
  ShopifyCustomersColumnServiceFactory,
  ExternalIntegrationSuccessCustomersColumnServiceFactory,
  ExternalIntegrationFailedCustomersColumnServiceFactory,
  AbandonedCartDelayFormService,
  ExternalIntegrationConnectFormService,
  SettingsIntegrationsColumnService,
  SettingsIntegrationsGridable,
  SettingsIntegrationsFilterServiceFactory,
  ExternalIntegrationSetupTitlerService,
  ExternalIntegrationTitlerService,
}

export type ExternalIntegrationsServices = keyof typeof SERVICES

export const EXTERNAL_INTEGRATIONS_SERVICES_TYPES: Record<ExternalIntegrationsServices, symbol> =
  makeServicesTypes<ExternalIntegrationsServices>(enumKeysToArray<ExternalIntegrationsServices>(SERVICES))
